import { ActionService } from 'dashboard-services/services';
import { AuthEnums } from 'dashboard-services/api/auth';

export default (() => {
  const MCP_CAPABILITIES = {
    CONNECT: {
      label: "Connect",
      value: AuthEnums.MCP_CAPABILITY.CONNECT
    },
    TOOLS_CALL: {
      label: "Call tool",
      value: AuthEnums.MCP_CAPABILITY.TOOLS_CALL
    }
  }
  const MCP_CAPABILITIES_BY_VALUE = Object.values(MCP_CAPABILITIES).reduce((capabilities, capability) => ({
    ...capabilities,
    [capability.value]: capability
  }), {})

  const ON_CHANGE = 'ON_CHANGE_COMPANY_MY_ACCOUNT'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')
  
  const ON_CHANGE_DETAILS = 'ON_CHANGE_COMPANY_DETAILS_MY_ACCOUNT'
  const onChangeDetails = ActionService.makeActionCreator(ON_CHANGE_DETAILS, 'value', 'name')

  const CLEAR_COMPANY = 'CLEAR_COMPANY_MY_ACCOUNT'
  const clearCompany = ActionService.makeActionCreator(CLEAR_COMPANY)

  const ADD_COMPANY_METADATA_FIELD = 'ADD_COMPANY_METADATA_MY_ACCOUNT'
  const addCompanyMetadataField = ActionService.makeActionCreator(ADD_COMPANY_METADATA_FIELD)

  const CHANGE_COMPANY_METADATA_FIELD = 'CHANGE_COMPANY_METADATA_FIELD_MY_ACCOUNT'
  const changeCompanyMetadataField = ActionService.makeActionCreator(CHANGE_COMPANY_METADATA_FIELD, 'value', 'name', 'index')

  const REMOVE_COMPANY_METADATA_FIELD = 'REMOVE_COMPANY_METADATA_FIELD_MY_ACCOUNT'
  const removeCompanyMetadataField = ActionService.makeActionCreator(REMOVE_COMPANY_METADATA_FIELD, 'index')

  return {
    onChange,
    ON_CHANGE,
    onChangeDetails,
    ON_CHANGE_DETAILS,
    CLEAR_COMPANY,
    clearCompany,
    ADD_COMPANY_METADATA_FIELD,
    addCompanyMetadataField,
    CHANGE_COMPANY_METADATA_FIELD,
    changeCompanyMetadataField,
    REMOVE_COMPANY_METADATA_FIELD,
    removeCompanyMetadataField,
    MCP_CAPABILITIES,
    MCP_CAPABILITIES_BY_VALUE,
  }
})()
